<template>
  <Dialog :modelValue="props.modelValue" @update:modelValue="$emit('update:modelValue', $event)" :title="$t('poolParty.loginDialog.title')">
    <div class="login-dialog" :class="cssType">
      <div class="form-item">
        <div class="label">{{ $t('payment.userDialog.id') }}</div>
        <div class="input">
          <HistoryUserIdInput
            class="input-box"
            v-model="state.userId"
            :locale="locale"
            :placeholder="$t('payment.validateUser.enterUserId')"
          />
        </div>
      </div>
      <PPButton class="confirm-btn" type="blue" @click="handleSubmit">{{ $t('payment.userDialog.confirmInput') }}</PPButton>
    </div>
  </Dialog>
</template>

<script setup>
import { defineProps, reactive, defineEmits } from 'vue'
import { isMobile } from '@/utils'
import Dialog from '@/components/Dialog/ActPoolParty/index.vue'
import PPButton from '@/views/act/poolParty/components/PPButton/index.vue'
import HistoryUserIdInput from '@/components/ValidateUser/HistoryUserIdInput/index.vue'
import { useI18n } from 'vue-i18n'
import { toastService } from '@/utils/toastService'
const { locale, t } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:modelValue', 'submit'])

const state = reactive({
  userId: ''
})

const handleSubmit = () => {
  if (!state.userId) {
    toastService.show(t('payment.validateUser.enterUserId'))
    return
  }
  emit('submit', state.userId)
  emit('update:modelValue', false)
}


</script>

<style lang="less" scoped src="./mobile_style.less"></style>
<style lang="less" scoped src="./pc_style.less"></style>